import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class MembershipPlansListQueryFilter extends QueryFilter{
    public organizationId: string;
}